import api from './api';
import types from './mutation-types';

export default {
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	postSearchSelectList_({ commit }) {
		return api
			.postSearchSelectList()
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'carScnList',
						value: data !== null && data !== undefined ? data.body.CAR_SCN : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pacScnList',
						value: data !== null && data !== undefined ? data.body.PAC_SCN : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'plntCdList',
						value: data !== null && data !== undefined ? data.body.PLNT_CD : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'flclSpcList',
						value: data !== null && data !== undefined ? data.body.FLCL_SPC : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'saleNatList',
						value: data !== null && data !== undefined ? data.body.SALE_NAT : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'occuRegnList',
						value: data !== null && data !== undefined ? data.body.OCCU_REGN : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getgrdList_({ commit, state }) {
		const { searchParams, pagingInfo } = state;
		return api
			.getgrdList({ searchParams: searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				//console.log("data ::", data)
				if (data.header.code === 0) {
					//그리드 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'grdList',
						value: data !== null && data !== undefined ? data.body.resultList : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pmcSaleListScrId',
						value: data.body.pmcSaleListScrId || ''
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
